"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeBuzzArticleDTO = exports.decodeBuzzArticleDTO = exports.encodeBuzzArticlesDTO = exports.decodeBuzzArticlesDTO = void 0;
const t = __importStar(require("io-ts"));
const E = __importStar(require("fp-ts/Either"));
const io_ts_types_1 = require("io-ts-types");
const function_1 = require("fp-ts/function");
const validation_error_1 = require("../errors/validation-error");
const codecs_1 = require("../codecs");
const BuzzArticlePreview = t.exact(t.partial({
    title: t.string,
    ingress: t.string,
    date: t.string,
}));
const BuzzArticles = t.exact(t.intersection([
    t.type({
        correlation_id: io_ts_types_1.UUID,
        article_urls: t.array(t.string),
        scraper_config: t.UnknownRecord,
        market: codecs_1.ISO3166Codec,
    }),
    t.partial({
        source_name: t.string,
        article_previews: t.record(t.string, BuzzArticlePreview),
    }),
]));
const BuzzArticle = t.exact(t.intersection([
    t.type({
        correlation_id: io_ts_types_1.UUID,
        article_url: t.string,
        scraper_config: t.UnknownRecord,
        market: codecs_1.ISO3166Codec,
    }),
    t.partial({
        source_name: t.string,
        article_preview: BuzzArticlePreview,
    }),
]));
exports.decodeBuzzArticlesDTO = (0, function_1.flow)(BuzzArticles.decode, E.mapLeft((0, validation_error_1.toValidationError)('BuzzArticles')));
exports.encodeBuzzArticlesDTO = BuzzArticles.encode;
exports.decodeBuzzArticleDTO = (0, function_1.flow)(BuzzArticle.decode, E.mapLeft((0, validation_error_1.toValidationError)('BuzzArticle')));
exports.encodeBuzzArticleDTO = BuzzArticle.encode;
//# sourceMappingURL=buzz-articles.js.map